import { get } from 'api/get';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';
import { format as formatDate } from 'date-fns';

import _ from 'lodash';

export const PPM_GET_AGGREGATE_REQUEST = 'ppm/get-aggregate/request';
export const PPM_GET_AGGREGATE_SUCCESS = 'ppm/get-aggregate/success';
export const PPM_GET_AGGREGATE_FAILURE = 'ppm/get-aggregate/failure';

export const PPM_GET_AGGREGATE_RANGE_REQUEST = 'ppm/get-aggregate/range/request';
export const PPM_GET_AGGREGATE_RANGE_SUCCESS = 'ppm/get-aggregate/range/success';
export const PPM_GET_AGGREGATE_RANGE_FAILURE = 'ppm/get-aggregate/range/failure';

export const PPM_SET_DATERANGE_FILTERS_SUCCESS = 'ppm/action/set-daterange-filters/success';

export function getAggregate(date) {
  return async (dispatch) => {

    dispatch({
      type: PPM_GET_AGGREGATE_REQUEST,
      payload: null
    });

    try {
      let qs = {}

      if (date instanceof Date) {
        qs['d'] = formatDate(date, 'yyyy-MM-dd');
      }

      let req = await get('reports/ppm/aggregate', qs);
      let data = _.get(req, 'data.payload', []);

      if(!data) {
        date.setDate(date.getDate()-1);
        if (date instanceof Date) {
          qs['d'] = formatDate(date, 'yyyy-MM-dd');
        }
        req = await get('reports/ppm/aggregate', qs);
        data = _.get(req, 'data.payload', []);
      }

      dispatch({
        type: PPM_GET_AGGREGATE_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: PPM_GET_AGGREGATE_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function getAggregateRange(startDate, endDate) {
  return async (dispatch) => {
    dispatch({
      type: PPM_GET_AGGREGATE_RANGE_REQUEST,
      payload: null
    });

    try {
      const req = await get('reports/ppm/aggregate-range', {
        sd: startDate,
        ed: endDate
      });
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: PPM_GET_AGGREGATE_RANGE_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: PPM_GET_AGGREGATE_RANGE_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function setDateRangeFilter(startDate, endDate) {
  return (dispatch) => {

    dispatch({
      type: PPM_GET_AGGREGATE_RANGE_REQUEST,
      payload: null
    });

    dispatch({
      type: PPM_SET_DATERANGE_FILTERS_SUCCESS,
      payload: {
        startDate: startDate,
        endDate: endDate
      }
    });
  }
}